module.exports = __webpack_public_path__ + "static/media/index-gift-hf.8a6a60fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index-gift-hf.png
// module id = 1925
// module chunks = 6